<template>
<div style="display: table;height:100%;width:100%">
    <div class="g-center">
      <h1 style="text-align:center">
        <p>404. 抱歉! 您访问的资源不存在!</p>
      </h1>
    </div>
  </div>
</template>

<script>
	export default {
		name: "err404"
	}
</script>

<style scoped>
  .g-center{
    display: table-cell;

    vertical-align: middle;
  }
</style>